import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "70vh",
    textAlign: "center",
    padding: theme.spacing(3),
    maxWidth: 520,
    margin: "0 auto",
  },
  title: {
    fontSize: "1.75rem",
    fontWeight: 700,
    marginBottom: theme.spacing(2),
    color: "#FF68D5",
  },
  body: {
    fontSize: "1rem",
    lineHeight: 1.6,
    marginBottom: theme.spacing(3),
    color: "rgba(255, 255, 255, 0.85)",
  },
  actions: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
    width: "100%",
    maxWidth: 360,
    marginBottom: theme.spacing(2),
  },
  primaryButton: {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 8,
    height: 48,
  },
  supportLink: {
    marginTop: theme.spacing(2),
    fontSize: "0.95rem",
    color: theme.palette.primary.main,
    textDecoration: "underline",
    "&:hover": {
      color: "#ff8fd8",
    },
  },
}));

export default useStyles;
